//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {Box, Link, Typography} from '@mui/material';
import IconEmail from 'assets/email.svg';
import IconTelegram from 'assets/telegram.svg';
import IconX from 'assets/x.svg';

//---------------------------------------------------------
// Functional Component
//---------------------------------------------------------
export default function Footer() {
	const copyright = '990 Foundation.\nA reference name for independent blockchain infrastructure work.';

	const telegram = 'https://t.me/foundation990';
	const email = 'mailto:hello@990.foundation';
	const x = 'https://x.com/990foundation';

	const is_wide = window.innerWidth > 768;

	return (
		<Box width="100%" marginBottom="10px" display="flex" flexDirection="column" alignItems="center" justifyContent="space-between" gap="20px" padding={2}>
			<Box display="flex" gap="20px" height={is_wide ? '50px' : '40px'} width="100%" justifyContent="center" alignItems="center" sx={{cursor: 'auto'}}>
				<Link href={x} target="_blank" rel="noopener noreferrer" underline="none">
					<Box
						height="100%"
						component="img"
						src={IconX}
						alt="x"
						sx={{
							transition: 'filter 0.3s',
							'&:hover': {
								filter: 'brightness(2.0)',
							},
							cursor: 'pointer',
							pointerEvents: 'auto',
						}}
					/>
				</Link>

				<Link href={telegram} target="_blank" rel="noopener noreferrer" underline="none">
					<Box
						height="100%"
						component="img"
						src={IconTelegram}
						alt="telegram"
						sx={{
							transition: 'filter 0.3s',
							'&:hover': {
								filter: 'brightness(2.0)',
							},
							cursor: 'pointer',
							pointerEvents: 'auto',
						}}
					/>
				</Link>

				<Link href={email} target="_blank" rel="noopener noreferrer" underline="none">
					<Box
						height="100%"
						component="img"
						src={IconEmail}
						alt="email"
						sx={{
							transition: 'filter 0.3s',
							'&:hover': {filter: 'brightness(2.0)'},
							cursor: 'pointer',
							pointerEvents: 'auto',
						}}
					/>
				</Link>
			</Box>

			<Typography variant="subtitle1" whiteSpace="pre-line" textAlign="center">
				{copyright}
			</Typography>
		</Box>
	);
}
